<template>
  <div>
    <Table />
    <Dialog />
  </div>
</template>

<script>
import Table from '../components/distro/Table.vue'
import Dialog from '../components/distro/Dialog.vue'

export default {
  components: { Table, Dialog }
}
</script>

<style scoped lang="scss">

</style>